export default __webpack_public_path__ + "static/media/background.8cfc98dc.svg";